import { textConstants } from '../constants/text.constants';
import textService from '../services/text.service';
import { alertActions } from './alert.actions';

export const textActions = {
  edit,
  fetch,  
  get  
};

function edit (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const text = await textService.edit(id, obj);
      dispatch(success(text));
      dispatch(alertActions.success("Texto alterado"));      
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: textConstants.UPDATE_REQUEST } }
  function success(text) { return { type: textConstants.UPDATE_SUCCESS, text } }
  function failure(error) { return { type: textConstants.UPDATE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const texts = await textService.fetch(params);        
      dispatch(success(texts));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: textConstants.FETCH_REQUEST } }
  function success(texts) { return { type: textConstants.FETCH_SUCCESS, texts } }
  function failure(error) { return { type: textConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const text = await textService.get(id);
      dispatch(success(text));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: textConstants.GET_REQUEST } }
  function success(text) { return { type: textConstants.GET_SUCCESS, text } }
  function failure(error) { return { type: textConstants.GET_FAILURE, error } }
}


